import { FileText, Mail } from 'lucide-react';
import type { CalendarPost } from '../../../lib/calendar/calendar-item';
import { contentMarkOf } from '../../../lib/calendar/content-mark';
import { socialPostHasLogo, socialPostLogoKey } from '../../../lib/social-post-preview-card';
import { SocialLogo } from '../ui/SocialLogo';
import { KIND_ICON } from './calendar-kinds';
import styles from './Calendar.module.css';

export function hasContentMark(post: CalendarPost | undefined): post is CalendarPost {
  return !!contentMarkOf(post);
}

export function CalendarContentMark({ post, size = 12 }: { post: Pick<CalendarPost, 'kind' | 'state' | 'preview' | 'idea'>; size?: number }) {
  const network = post.kind === 'social' ? (post.preview?.network ?? post.idea?.network) : undefined;
  const mark = contentMarkOf(post) ?? { kind: post.kind, ...(network ? { network } : {}), muted: false };
  const muted = mark.muted ? styles.contentMarkMuted : '';
  const tag = { 'data-testid': 'calendar-content-mark', 'data-kind': mark.kind, 'data-muted': mark.muted || undefined };
  if (mark.kind === 'email') return <Mail size={size} className={`${styles.itemIcon} ${muted}`} {...tag} aria-hidden />;
  if (mark.kind === 'blog') return <FileText size={size} className={`${styles.itemIcon} ${muted}`} {...tag} aria-hidden />;
  if (mark.network && socialPostHasLogo(mark.network)) {
    return (
      <span className={`${styles.contentMark} ${muted}`} style={{ width: size, height: size }} {...tag} aria-hidden>
        <SocialLogo network={socialPostLogoKey(mark.network)} size={size} />
      </span>
    );
  }
  const Icon = KIND_ICON.task;
  return <Icon size={size} className={`${styles.itemIcon} ${muted}`} {...tag} aria-hidden />;
}
